import track, {TRACK_TYPES} from '@/dex-shared/helpers/track';
import { VueConstructor } from 'vue';
import { Dispatch } from 'vuex';

export default {
    install (Vue: VueConstructor, options: { dispatch: Dispatch }) {
        const { dispatch } = options;
        Vue.prototype.$track = track(dispatch);
    }
}